import { useMemo } from 'react'
import { ChartData } from 'chart.js'
import { IMountainPlayerData } from '../data/mountainPlayer'
import { IGameActivity } from '../data/question'
import { buildColorsArray, buildDataValues, buildLabelsArray, chartValues } from '../utils/chart'

const useBuildClassPerformanceData = (
	players: Array<IMountainPlayerData>,
	activity: IGameActivity,
	areAnswersHidden: boolean
): ChartData<'bar'> => {
	const answers = activity.payload.answers

	// useMemo is used to avoid re-rendering the chart when the data is not changed
	const labels: Array<string> = useMemo(() => buildLabelsArray(answers, areAnswersHidden), [areAnswersHidden, answers])

	const backgroundColor = useMemo(
		() => buildColorsArray(answers, areAnswersHidden, 'filling'),
		[answers, areAnswersHidden]
	)

	const borderColor = useMemo(() => buildColorsArray(answers, areAnswersHidden, 'border'), [answers, areAnswersHidden])

	const data = useMemo(() => buildDataValues(players, answers, areAnswersHidden), [players, answers, areAnswersHidden])

	const borderRadius = data.map((value) => (value === 0 ? 0 : chartValues.borderRadius))

	const chartBorderColors = data.map((value, index) =>
		value <= 0 ? chartValues.pallete.border.zero : borderColor[index]
	)

	const chartBackgroundColor = data.map((value, index) =>
		value <= 0 ? chartValues.pallete.filling.zero : backgroundColor[index]
	)

	return {
		labels,
		datasets: [
			{
				label: 'Student',
				data,
				barPercentage: 1.15,
				backgroundColor: chartBackgroundColor,
				borderColor: chartBorderColors,
				borderRadius,
				minBarLength: chartValues.minBarLength,
			},
		],
	}
}

export default useBuildClassPerformanceData
